import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { OrderDTO } from '../../../../shared/order-dto';
import { CustomerService } from '../customer.service';
import { CheckoutDTO } from '../../../../shared/checkout-dto';
import { currencyRound } from '../../../../src/constants';
import { CartItemDTO } from '../../../../shared/cart-dto';
import { AccountService } from '../account.service';
import { AccountDTO } from '../../../../shared/account-dto';

@Component({
  selector: 'pv-order-receipt',
  templateUrl: './order-receipt.component.html',
  styleUrls: ['./order-receipt.component.scss']
})
export class OrderReceiptComponent implements OnChanges, OnInit {
  @Input() order: OrderDTO;
  @Input() useCart: boolean;
  @Input() separate: boolean;
  @Output() onUseCredits: EventEmitter<boolean> = new EventEmitter<boolean>();
  useCredits: boolean = false;
  checkoutDTO: CheckoutDTO;
  currentCartItems: CartItemDTO[];
  availableCredits = 0;
  allowedCredits = 0;

  // On Receipt
  totalPretax = 0;
  shippingRate = 0;
  taxAmount = 0;
  couponCode = '';
  couponDiscount = 0;
  total = 0;
  shippingName: string;

  // after credits
  creditAmount = 0;
  grandTotal = 0;
  account: AccountDTO

  constructor(
    private customerService: CustomerService,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)
  }

  ngOnChanges() {
    if (this.useCart) {
      this.checkoutDTO = this.customerService.checkoutDTO
      if (this.separate) {
        this.currentCartItems = this.checkoutDTO.cart.items.filter(i => !i.isPreorder)
      } else {
        this.currentCartItems = this.checkoutDTO.cart.items
      }

      this.customerService.checkoutSubject.subscribe(checkoutDTO => {
        this.checkoutDTO = checkoutDTO;
        if (this.separate) {
          this.currentCartItems = this.checkoutDTO.cart.items.filter(i => !i.isPreorder)
        } else {
          this.currentCartItems = this.checkoutDTO.cart.items
        }
        this.updateNumbers()
      })
    }
  }

  updateNumbers() {
    console.warn('todo://change updatenumbers to account for different shippingRates')
    // UPDATE ALL THE NUMBERS
    this.totalPretax = this.checkoutDTO.cart.totalPretax;
    if (this.checkoutDTO.shippingRate1) {
      this.shippingRate = this.checkoutDTO.shippingRate1.rate
      this.shippingName = this.checkoutDTO.shippingRate1.full_label
    } else {
      this.shippingRate = 0;
      this.shippingName = null;
    }

    this.total = this.totalPretax + this.shippingRate + this.taxAmount;

    this.availableCredits = this.getGiftCard(this.checkoutDTO)
    this.allowedCredits = Math.min(this.total, this.availableCredits)

    if (this.useCredits) {
      this.creditAmount = this.allowedCredits
    } else {
      this.creditAmount = 0;
    }

    this.couponCode = this.checkoutDTO.cart.couponCode
    this.couponDiscount = this.checkoutDTO.cart.couponDiscount

    this.grandTotal = currencyRound(this.total - this.creditAmount);
  }

  toggleCredits() {
    this.useCredits = !this.useCredits
    this.onUseCredits.emit(this.useCredits)
  }

  onRedeem() {
    this.useCredits = true;
    this.onUseCredits.emit(this.useCredits);
  }

  getDiscount() {
    const itemTotal = this.order.items.reduce((sum, item) => sum + (item.quantity * item.sold_price), 0)
    const shipping = this.order.shipping_amount;
    const tax = this.order.tax_amount

    const withoutDiscount = itemTotal + shipping + tax
    const withDiscount = this.order.total_pretax + shipping + tax

    return withoutDiscount - withDiscount
  }

  getGiftCard(checkout: CheckoutDTO) {
    return checkout.customer.credits && checkout.customer.credits.reduce((sum, credit) => {
      if (credit.expire_datetime) {
        const expire = new Date(credit.expire_datetime);
        if (new Date() < expire) {
          return sum + credit.amount
        } else {
          return sum;
        }
      }
      return sum + credit.amount
    }, 0)
  }



}
